export function getThemesUrl(themeType, ordColumnName, ordIsAscending, highlightThemeId = false) {
    let s =  `/themes/${themeType}?ordColumnName=${ordColumnName}&ordIsAscending=${ordIsAscending?'yes':'no'}`;
    if (highlightThemeId && highlightThemeId.length) {
        s += `&highlightThemeId=${highlightThemeId}`;
    }
    return s;
}
